import { FlagProps } from './phone-field.types';

export const FlagPropsKeys = [
  'defaultCountryCode',
  'flagMode',
  'highlights',
  'selectableCountries',
  'onCountryChange',
] as const satisfies readonly (keyof FlagProps)[];

/**
 * Defines the threshold for optimized countries count.
 * Above this number, flags should use sprite mode for better performance.
 */
export const OPTIMIZED_COUNTRIES_COUNT = 10;
